<template>
    <div class="search-result-wrapper card" @click="onClickItem(item)">
        <strong>{{ item.tankstelle }}</strong>
        <address class="my-0"><small>{{item.address.street}} {{item.address.street_number}} <br>{{item.address.zip}} {{item.address.city}}</small></address>
        <address class="my-0">
            <small>
                <span title="Telefon"><i class="fa fa-phone"></i></span>&emsp;{{item.contact.phone}}<br>
                <span title="Fax"><i class="fa fa-fax"></i></span>&emsp;{{item.contact.fax}}<br>
                <a :href="'mailto: {{item.contact.email}}'">
                    <span title="E-Mail"><i class="fa fa-envelope"></i></span>&emsp;{{item.contact.email}}
                </a>
            </small>
        </address>
    </div>
</template>

<script>
    export default {
      props: {
        item: { required: true }
      },
        methods: {
            onClickItem(item) {
                this.$emit('item-clicked', item)
            }
        }
    }
</script>

<style lang="scss">
    .search-result-wrapper {
        padding: .5rem 1rem;
        border-bottom: 1px solid darkgray;
        &:last-of-type {
            border-bottom: none;
        }
    }

    .card {
        background-color: #FFF;
        cursor: pointer;
        margin-bottom: 5px;
        box-shadow:0 0 20px rgba(0, 0, 0, 0.15);
        border-left: 8px solid transparent;
        transition: all .25s ease-in;
        &:hover {
            border-left: 8px solid #BA0C2F;
            transition: all .25s ease-out;
        }
    }

    .card .row {
        width:100%;
        margin-bottom:10px;
    }
    .card .row p,
    .card .row .link {
        font-size: .7em;
        line-height: 1.4;
    }
    .card .row p {
    }
    .card .row .link {
    }

    .no-item,
    .no-item-fade-enter-active, .no-item-fade-leave-active {
        display: flex;
        justify-content:center;
        align-items:center;
    }
    .no-item {
    }
    .no-item-fade-enter-active, .no-item-fade-leave-active,
    .fade-enter-active, .fade-leave-active {
        transition: all 1s ease .5s;
    }
    .no-item-fade-enter, .no-item-fade-leave-to,
    .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
        opacity: 0
    }

    .no-item-fade-enter, .no-item-fade-leave-to {
        height: 0;
        margin-bottom: 0;
    }

    /* stagger css */

    .staggered-enter-active, .staggered-leave-active {
        transition: all .8s ease-in;
        overflow: hidden;
        margin: 0;
        height: 150px;

    }
    .staggered-enter, .staggered-leave-to {
        opacity: 0;
        height: 0;
    }
</style>



// WEBPACK FOOTER //
// resultsTemplate.vue?735eaf22